var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpTri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19995 14C8.04995 14 7.92912 13.95 7.83745 13.85C7.74578 13.75 7.69995 13.6334 7.69995 13.5C7.69995 13.4667 7.74995 13.35 7.84995 13.15L11.475 9.52505C11.5583 9.44172 11.6416 9.38338 11.725 9.35005C11.8083 9.31672 11.9 9.30005 12 9.30005C12.1 9.30005 12.1916 9.31672 12.275 9.35005C12.3583 9.38338 12.4416 9.44172 12.525 9.52505L16.15 13.15C16.2 13.2 16.2375 13.2542 16.2625 13.3125C16.2875 13.3709 16.3 13.4334 16.3 13.5C16.3 13.6334 16.2541 13.75 16.1625 13.85C16.0708 13.95 15.95 14 15.8 14H8.19995Z",
    fill: "#101014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpTri);
export default __webpack_public_path__ + "static/media/up_tri.1e903ca7d0987eb2c50814a1aac13dd5.svg";
export { ForwardRef as ReactComponent };